import React from 'react'
import { Container, Typography } from '@cleartrip/ct-design-components'
import FlightDetailsRoute from '@/assets/icons/FlightDetailsRoute'
import { getFlightLogoUrl } from '@/utils/images'
import ImageBlock from '@/components/imageBlock'

interface FlightRouteInfoProps {
    duration: any
    airlineCode: string
    fltNo: string
    airlineName: string
    isIntl: boolean
}

const FlightRouteInfo = ({ duration = {}, airlineCode, fltNo, airlineName, isIntl=false , shouldShowOperatingAirline=false, operatingAirlineName=''}: FlightRouteInfoProps) => {
    const { hh = 0, mm = 0 } = duration || {}
    return (
        <Container className="flex flex-middle">
            <Container width="60px" className="ws-nowrap">
                <Typography variant="B2" color="subheading">
                    {hh < 10 ? `0${hh}` : hh}h {mm < 10 ? `0${mm}` : mm}m
                </Typography>
            </Container>
            <Container className="flex flex-center" style={{ width: '43px' }}>
                <FlightDetailsRoute />
            </Container>
            <Container className="flex flex-column gap-2" >
                <Container className="flex flex-middle ml-4">
                    <ImageBlock
                        path={getFlightLogoUrl(airlineCode, isIntl ? 'circle_logo' : '')}
                        isCircleLogo={isIntl}
                        altText={airlineCode}
                        width={28}
                        height={28}
                        customClass={'br-100'}
                    />
                    <Container className="ml-2 flex">
                        <Typography variant="HM4">{airlineName}&nbsp;</Typography>
                        <Typography variant="B2" color="subheading">
                            &#183;&nbsp;{`${airlineCode}-${fltNo}`}
                        </Typography>
                    </Container>
                </Container>
                <Container className="flex ml-4 pl-9">
                    {shouldShowOperatingAirline && (
                        <Typography variant="B3" color="subheading">
                            Operated by {operatingAirlineName}
                        </Typography>
                    )}
                </Container>
            </Container>
        </Container>
    )
}

export default FlightRouteInfo
